import CardUserHorizontal from "./card-user-horizontal";

import "./card-user.scss";


const CardUser = {
    Horizontal : CardUserHorizontal
}

export default CardUser;